import api from '@/api'

const namespaced = true

const state = {
  usernames: [],
  locations: [],
  logs: [],
  logFile: null
}

const getters = {
  usernames: state => state.usernames,
  locations: state => state.locations,
  logs: state => state.logs,
  logFile: state => state.logFile
}

const mutations = {
  SET_USERNAMES: (state, payload) => {
    state.usernames = payload
  },
  SET_LOCATIONS: (state, payload) => {
    state.locations = payload
  },
  SET_LOGS: (state, payload) => {
    state.logs = payload
  },
  SET_LOG_FILE: (state, payload) => {
    state.logFile = payload
  }
}

const actions = {
  async fetchUsernames({ commit }, payload) {
    try {
      const { data } = await api.getUsernames(payload)
      if (data.error) {
        commit('SET_USERNAMES', [])
        return
      }

      commit('SET_USERNAMES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchLocations({ commit }, payload) {
    try {
      const { data } = await api.getUserLocations(payload)
      if (data.error) {
        commit('SET_LOCATIONS', [])
        return
      }

      commit('SET_LOCATIONS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchLogs({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...payload,
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize
      }

      const { data } = await api.getUserLogs(filter)
      if (data.error) {
        commit('SET_LOGS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_LOGS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async downloadLogs({ commit }, payload) {
    try {
      const response = await api.downloadLogs(payload)
      if (response.data.error) {
        commit('SET_LOG_FILE', null)
        return
      }

      commit('SET_LOG_FILE', response)
    } catch (err) {
      throw err
    }
  },
  async postUserLogs(_, payload) {
    try {
      await api.postUserLog(payload)
    } catch (err) {
      throw err
    }
  },
  resetLogFile({ commit }) {
    commit('SET_LOG_FILE', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
